/**
 * @generated SignedSource<<1603a8b4c254b3b98910b9d3424a69a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TxnClassificationEnum = "CHARGEBACK" | "DIVIDEND" | "FINANCING_FEE" | "FRAUDULENT" | "LOAN_PROCEEDS" | "LOAN_REPAYMENT" | "PROCESSOR_FEE" | "REFUND" | "SALARY" | "TAX_PAYMENT" | "TAX_REFUND" | "%future added value";
export type ClassifyTxnsInputObject = {
  classification?: TxnClassificationEnum | null | undefined;
  txnIds: ReadonlyArray<string>;
};
export type stakeholderTxnsDialog_ClassifyTxnsMutation$variables = {
  input: ClassifyTxnsInputObject;
};
export type stakeholderTxnsDialog_ClassifyTxnsMutation$data = {
  readonly classifyTxns: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly updatedCount: number;
  } | null | undefined;
};
export type stakeholderTxnsDialog_ClassifyTxnsMutation = {
  response: stakeholderTxnsDialog_ClassifyTxnsMutation$data;
  variables: stakeholderTxnsDialog_ClassifyTxnsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "stakeholderTxnsDialog_ClassifyTxnsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClassifyTxnsMutationPayload",
        "kind": "LinkedField",
        "name": "classifyTxns",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "stakeholderTxnsDialog_ClassifyTxnsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClassifyTxnsMutationPayload",
        "kind": "LinkedField",
        "name": "classifyTxns",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3e006e6663ee499e638434dc21175c7f",
    "id": null,
    "metadata": {},
    "name": "stakeholderTxnsDialog_ClassifyTxnsMutation",
    "operationKind": "mutation",
    "text": "mutation stakeholderTxnsDialog_ClassifyTxnsMutation(\n  $input: ClassifyTxnsInputObject!\n) {\n  classifyTxns(input: $input) {\n    updatedCount\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6002b1d8af0e45e4072b8a1994b45ab0";

export default node;
